module.exports = __webpack_public_path__ + "media/images/circle-blanked-10d47ca186c94cc185c6294414adf0e2.svg";